import type { IconData } from '@stacksjs/iconify-core'

export const tableLeftHeader: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 2v10h8V2zM2 0h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export default tableLeftHeader
